import React from 'react'
import WILSectionTitle from './WILSectionTitle';
import { Element } from 'react-scroll';

const WILBusinesses = () => {
  return (
    <Element
      name="WILForBusinesses"
      className="datatalent-section-gap wil-businesses"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 justify-content-center">
          <div className="col-12 mt-0 col-lg-7 px-0 px-md-4">
            <div className={`section-title text-start`}>
              <h3 className="title" style={{color: "#F5D64E"}}>WIL For Businesses</h3>
            </div>
            <p className="wil-program-features color-white">
              At M2M Tech, we partner with businesses to provide AI-ready talent through structured Work-Integrated Learning (WIL) programs. Our initiative helps companies leverage skilled professionals while supporting workforce development in Data Science, Machine Learning and AI.
            </p>
            <div className="wil-businesses-features row g-5">
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <h5 style={{color: "#F5D64E"}}>Access to Skilled Talent</h5>
                <ul className="mb-0">
                  <li className="color-white">Gain early access to emerging talent in Data Science, Machine Learning and AI.</li>
                  <li className="color-white">Work with students and professionals trained in cutting-edge technologies.</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <h5 style={{color: "#F5D64E"}}>Cost-Effective Workforce Support</h5>
                <ul className="mb-0">
                  <li className="color-white">WIL participants provide project-based assistance at a lower cost than hiring full-time employees.</li>
                  <li className="color-white">Some programs are government-funded, reducing financial risk.</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <h5 style={{color: "#F5D64E"}}>Fresh Perspectives & Innovation</h5>
                <ul className="mb-0">
                  <li className="color-white">New talent brings innovative ideas and solutions to real business challenges.</li>
                  <li className="color-white">Exposure to the latest academic research and industry best practices.</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <h5 style={{color: "#F5D64E"}}>AI & Digital Transformation Readiness</h5>
                <ul className="mb-0">
                  <li className="color-white">Apply AI-driven solutions in real-world business settings with expert guidance.</li>
                  <li className="color-white">Test new AI models, automation, and analytics without committing to full-time AI hires.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 mt-0 col-lg-5 px-0 px-md-4">
            <div className="wil-how-it-works row">
              <div className="col-12 px-0 px-md-4">
                <h4 style={{color: "#F5D64E"}}>How it works</h4>
              </div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <div className="wil-how-it-works-point d-flex gap-4">
                  <h4 style={{color: "#F5D64E"}}>1</h4>
                  <p className="color-white">
                    <strong>Define Your Project</strong>:<br></br>
                    Identify a Data Science, Machine Learning and AI project.
                  </p>
                </div>
              </div>
              <div className="d-none d-md-block col-lg-6"></div>
              <div className="d-none d-md-block col-lg-2"></div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <div className="wil-how-it-works-point d-flex gap-4">
                  <h4 style={{color: "#F5D64E"}}>2</h4>
                  <p className="color-white">
                    <strong>We Match You with Talent</strong>:<br></br>
                    Select from vetted participants ready to contribute.
                  </p>
                </div>
              </div>
              <div className="d-none d-md-block col-lg-4"></div>
              <div className="d-none d-md-block col-lg-4"></div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <div className="wil-how-it-works-point d-flex gap-4">
                  <h4 style={{color: "#F5D64E"}}>3</h4>
                  <p className="color-white">
                    <strong>Collaborate on Real-World Solutions</strong>:<br></br>
                    Work on AI-driven projects with talent from M2M Tech.
                  </p>
                </div>
              </div>
              <div className="d-none d-md-block col-lg-2"></div>
              <div className="d-none d-md-block col-lg-6"></div>
              <div className="col-12 col-lg-6 px-0 px-md-4">
                <div className="wil-how-it-works-point d-flex gap-4">
                  <h4 style={{color: "#F5D64E"}}>*</h4>
                  <p className="color-white mb-0">
                    Evaluate & Hire (Optional)<br></br>
                    Seamlessly transition top performers into full-time roles.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      </Element>
  )
}

export default WILBusinesses;